var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASElEQVR42mMYBTQCTyUlG/CLETZAAVkDiA0SAzIdiDZkGT+/DkwDkmYBUn0jgMwmORzI8T+mnzHDhDDA9DMiTMj0P0JsGKZaAGMzF8Nh49O6AAAAAElFTkSuQmCC";
  export default img;